"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ActivationPrompt;
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _styles = require("@sart/styles");
var _client = _interopRequireDefault(require("@sart/client"));
var _content = require("@sart/content");
var _Text = _interopRequireDefault(require("./Text"));
var _Label = _interopRequireDefault(require("./Label"));
var _Space = _interopRequireDefault(require("./Space"));
var _Anchor = _interopRequireDefault(require("./Anchor"));
var _Button = _interopRequireDefault(require("./Button"));
require("moment/locale/es-us");
require("moment/locale/en-gb");
function ActivationPrompt(props) {
  var titleStyle = props.titleStyle,
    cashContainer = props.cashContainer,
    buttonTitleStyle = props.buttonTitleStyle,
    onPress = props.onPress,
    buttonStyle = props.buttonStyle,
    disabledButtonStyle = props.disabledButtonStyle,
    disabled = props.disabled,
    errorMessage = props.errorMessage,
    processing = props.processing;
  var content = (0, _content.useContent)();
  var language;
  if (_client["default"].cache.language === 'en') {
    language = 'en-gb';
  } else if (_client["default"].cache.language === 'es') {
    language = 'es-us';
  }
  ;
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: cashContainer ? cashContainer : styles.container
  }, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: titleStyle ? titleStyle : styles.label
  }, content.dashboard.activatePrompt), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 24
  }), errorMessage && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: styles.error
  }, errorMessage), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 24
  })), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    title: processing ? ['Activating ', /*#__PURE__*/_react["default"].createElement(_reactNative.ActivityIndicator, {
      size: "small",
      color: _styles.colors.brightOrange,
      style: {
        paddingLeft: 8
      }
    })] : content.dashboard.activate,
    onPress: onPress,
    titleStyle: buttonTitleStyle,
    style: buttonStyle,
    disabledStyle: disabledButtonStyle,
    disabled: disabled
  }), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 12
  }));
}
var styles = _reactNative.StyleSheet.create({
  container: {
    padding: 24,
    backgroundColor: _styles.backgroundColors.clear,
    borderRadius: _styles.radius.medium,
    elevation: 8
    // ...shadows.shadowByElevation(8)
  },
  name: {
    fontSize: 32,
    lineHeight: 48,
    fontWeight: '700',
    color: _styles.colors.feature
  },
  row: {
    flexDirection: 'row'
  },
  column: {
    flex: 1,
    flexDirection: 'column'
  },
  label: {
    fontSize: 14,
    lineHeight: 24
  },
  text: {
    fontSize: 14,
    lineHeight: 24,
    color: _styles.colors.feature
  },
  cancel: {
    color: _styles.colors.trivial,
    textAlign: 'center'
  },
  error: {
    color: 'red',
    textAlign: 'center'
  }
});